import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {SupportVm} from 'src/app/view-model/support/support.vm';

@Injectable({
  providedIn: 'root',
})
export class SupportGuard implements CanActivate {
    
  constructor(
    private router: Router,
    private supportVm: SupportVm
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    this.supportVm.openChat();
    return false;
  
  }
}
